const BASE_URL = 'https://api.kreators.community';

export async function getKreators(custom_name?: string) {
  const response = await fetch(
    `${BASE_URL}/api/auth/facebook/auth_url${custom_name ? `?custom_name=${custom_name}` : ''}`,
  );
  return response.json();
}
